import moment from 'moment'
import { DateRangeValue } from '@microservices/wiskey-react-components'

export const truncateDateTimeToMinute = (date: DateRangeValue) => {
  if (date) {
    return moment(date).startOf('minute').toISOString()
  }

  return date
}
